import React, { FunctionComponent } from "react"
import { Button, Modal } from "react-bootstrap"
import EALAService from "../EALAService"
import "./Trees.css"

interface Props {
    manageParentState: Function
    treeProfitCenterID: number
}

const ProfitCenterHierarchyTree: FunctionComponent<Props> = (props) => {

    const { manageParentState, treeProfitCenterID } = props
    const { getProfitCenterFromStateHierarchyTree } = EALAService
    const profitCenterItem = getProfitCenterFromStateHierarchyTree(treeProfitCenterID)

    return (
        <div className="HierarchyTree">
            <Modal
                id="profit-center-hierarchy-tree-modal"
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
                size="sm"
            >
                <Modal.Header>
                    <div className="HierarchyTreeModalHeader">
                        <p>{profitCenterItem.profitCenter.ProfitCenterLongDesc}</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="HierarchyTreeModalBody">
                        {profitCenterItem.serviceAreas.map((serviceAreaItem, i) =>
                            <div className="HierarchyTreeModalSABranch" key={i}>
                                <div className="HierarchyTreeModalSABranchTitle">
                                    <p className="HierarchyTreeModalSABranchTitleText">{serviceAreaItem.ServiceAreaLongDesc}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="HierarchyTreeModalFooter">
                        <Button variant="secondary" onClick={() => manageParentState([{ key: "treeProfitCenterID", value: -1 }])}>Back</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ProfitCenterHierarchyTree